import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { DEFAULT_JOB_TYPES, paths } from "@clevis/shared-types";
import { db } from "../lib/firebase";

// The company's job types (Jobs → Job settings), or the defaults until set.
export function useJobTypes(tenantId: string | null): string[] {
  const [types, setTypes] = useState<string[]>(DEFAULT_JOB_TYPES);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(doc(db, paths.tenant(tenantId)), (snap) => {
      const t = snap.get("jobTypes") as string[] | undefined;
      setTypes(t && t.length > 0 ? t : DEFAULT_JOB_TYPES);
    });
  }, [tenantId]);
  return types;
}
